import { render, staticRenderFns } from "./termsAndCondition.vue?vue&type=template&id=056a3092&"
import script from "./termsAndCondition.vue?vue&type=script&lang=js&"
export * from "./termsAndCondition.vue?vue&type=script&lang=js&"
import style0 from "./termsAndCondition.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports